export default "__VITE_ASSET__DpBvJEZ5__"